import React, { Component } from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { routeActions } from 'react-router-redux';
import { translate } from 'react-i18next';
import './PortalMenu.css';
import 'animate.css';
var logoASMSETTINGSBlanc = require('./logo-Amphitech-blanc-RVB.png');
import { isMobile } from 'react-device-detect';

const desktopStyles = {
  position: 'absolute',
  left: '50%',
  top: 0,
  opacity: '0.9',
  background: 'rgb(28 42 104)',
  borderRadius: '0px 0px 15px 15px',
  zIndex: '99999999999999',
  color: 'white',
  fontSize: '70%',
  width: '100px',
  textAlign: 'center',
  fontWeight: 'bold',
  height: '19px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const smallStyles = {
  position: 'absolute',
  top: 0,
  left: '50%',
  opacity: '0.9',
  transform: 'translateX(-50%)',
  background: 'rgb(28 42 104)',
  zIndex: '99999999999999',
  color: 'white',
  fontSize: '70%',
  width: '100%',
  height: '35px',
  textAlign: 'center',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

@translate(['common'])
@connect(
  state => ({
    user: state.auth.user,
    tokenExpired: state.auth.tokenExpired,
    loadError: state.errors.loadError,
    routeChanges: state.routing.location,
    anomalies: state.supervisionErrors.all,
    loadingBar: state.loadingBar,
  }),
  { pushState: routeActions.push }
)
class PortalMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { showNavbar: false, width: undefined, height: undefined };
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('resize', this.handleResize);
  }

  handleMouseMove(e) {
    var y = this.state.showNavbar ? 80 : 7;
    if (e.clientY !== 0) {
      if (e.clientY < y) {
        //this.setState({ showNavbar: true });
      } else {
        this.setState({ showNavbar: false });
      }
    }
  }

  render() {
    const { showNavbar, width } = this.state;
    const isServer = typeof window === 'undefined';
    const isSmallScreen = width <= 768;
    const animationClass = `animate__animated ${showNavbar ? 'animate__slideInDown' : 'animate__slideOutUp'} fast-animation`;

    const logo = (
      <div style={{
        display: 'flex', // Utilise Flexbox pour organiser les éléments
        alignItems: 'center', // Centre les éléments verticalement
        //marginLeft: '0px',
        //width: '393px',
        //height: '50px',
        zoom: isSmallScreen ? '84%' : '100%',
        width: isSmallScreen ? '100%' : 'auto',
        justifyContent: isSmallScreen ? 'center' : 'none',
        display: 'flex',
        marginTop: '5px',
      }}>
        <a href={"https://amphitech.fr?ln=" + this.props.lng}>
          <img width='200' src={logoASMSETTINGSBlanc} alt="Logos" style={{ flexShrink: 0 }} />
        </a>
        <div style={{ marginLeft: '15px', marginTop: '12px' }}>
          <a id="portal-link" href={this.props.lng === 'fr' ? 'https://portail.amphitech.fr' : this.props.lng === 'en' ? 'https://portal.amphitech.fr' : 'https://portal.amphitech.fr?l=' + this.props.lng}>
            <span style={{ fontSize: "25px", color: 'white', fontWeight: '500', display: 'flex', alignItems: 'center', fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji" }}>
              |&nbsp;&nbsp;
              PORTAIL&nbsp;
              <span style={{ color: 'rgb(232 66 60)' }}> ASM</span>
            </span>
          </a>
        </div>
      </div>
    );

    return (
      <div id="portal-menu" style={{ maxHeight: isSmallScreen ? '35px' : '0' }}>
        {!isServer && (
          <Navbar
            className={animationClass}
            style={{ background: 'rgb(28, 42, 104)', padding: '10px', color: 'white', zIndex: '9999999', border: 'none' }}
            expand="lg"
          >
            <Navbar.Header style={{
              marginTop: '-13px', height: '60px',
              display: 'flex',
              justifyContent: 'center'
            }}>
              <div style={{ cursor: 'pointer' }}>
                <Navbar.Brand>
                  {logo}
                </Navbar.Brand>
              </div>
            </Navbar.Header>
            <Navbar.Collapse style={{ display: showNavbar ? 'flex' : 'none', justifyContent: 'center' }}>
              <Nav style={{ display: 'flex', width: '100%', justifyContent: 'center', flexDirection: isSmallScreen ? 'column' : 'inherit' }} id="portalMenuNav">
                <NavItem eventKey={2} href={`https://asm-securit.amphitech.fr/${this.props.lng}/freeasm`}>
                  ASM FREE
                </NavItem>
                <NavItem eventKey={3} href={`https://asm-securit.amphitech.fr/${this.props.lng}`}>
                  ASM SECURIT
                </NavItem>
                <NavItem eventKey={1} href={`https://asm-settings.amphitech.fr/${this.props.lng}`}>
                  ASM SETTINGS
                </NavItem>
                <NavItem eventKey={4} href={`https://sts.amphitech.fr/?l=${this.props.lng}`}>
                  ASM STS
                </NavItem>
                <NavItem eventKey={5} href={`https://asm-lift.amphitech.fr/?l=${this.props.lng}`}>
                  ASM LIFT
                </NavItem>
                <NavItem eventKey={6} href={`https://asm-access.amphitech.fr/${this.props.lng}`}>
                  ASM ACCESS
                </NavItem>

                {(showNavbar && (isSmallScreen)) && (
                  <NavItem onClick={() => this.setState({ showNavbar: false })} href="#" aria-label="Remonter le menu">
                    <i className="fa fa-chevron-up" style={{fontSize:'14px'}}></i>
                  </NavItem>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        )}
        {!showNavbar && (
          <div style={isSmallScreen ? smallStyles : desktopStyles} onMouseEnter={() => this.setState({ showNavbar: true })} onClick={() => this.setState({ showNavbar: true })}>
            <div>PORTAIL <span style={{ color: 'rgb(232 66 60)' }}>ASM</span></div>
          </div>
        )}
        {this.props.children}
      </div>
    );
  }
}

export default PortalMenu;
